import FormCheckboxRadio from 'components/common/FormCheckboxRadio';
import { DESKTOP_MIN_WIDTH } from 'constants';
import {
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_FINDER_NAME,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_POST_CODE_NAME,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_STATE_NAME,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_STREET_NAME_NAME,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_STREET_NO_NAME,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_STREET_TYPE_NAME,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_SUBURB_NAME,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_SWITCH,
  FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_UNITNAME_NAME,
} from 'constants/fx';
import { Fade } from 'helpers/animation';
import useLang from 'hooks/useLang';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';

const FormInputAddressSwitch = ({
  information,
  setInformation,
  validation,
  setValidation,
}) => {
  const { t } = useLang();
  const { isEnterAddressManuallySelected } = information;

  const isFinder = !isEnterAddressManuallySelected;
  const isManual = isEnterAddressManuallySelected;

  const isDisabled = false;

  const handleOnChange = (value) => {
    setInformation({
      ...information,
      isEnterAddressManuallySelected: value,
    });

    setValidation({
      ...validation,
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_FINDER_NAME]: '',
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_UNITNAME_NAME]: '',
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_STREET_NO_NAME]: '',
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_STREET_NAME_NAME]: '',
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_STREET_TYPE_NAME]: '',
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_POST_CODE_NAME]: '',
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_SUBURB_NAME]: '',
      [FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_STATE_NAME]: '',
    });
  };

  const renderFormCheckRadio1 = () => {
    const formCheckRadioClassName1 =
      FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_SWITCH + '1';

    return (
      <>
        <FormCheckboxRadio
          name={FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_SWITCH}
          className={`${formCheckRadioClassName1} ${isFinder ? 'active' : ''}`}
          label={t('fx_confirm_personal_address_option_1')}
          isChecked={isFinder}
          onClick={() => (!isDisabled ? handleOnChange(false) : {})}
          styles={{ marginRight: '16px' }}
        />
      </>
    );
  };

  const renderFormCheckRadio2 = () => {
    const formCheckRadioClassName2 =
      FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_SWITCH + '2';

    return (
      <>
        <FormCheckboxRadio
          name={FX_ADD_TRANSACTION_ENTER_INFORMATION_ADDRESS_SWITCH}
          className={`${formCheckRadioClassName2} ${isManual ? 'active' : ''}`}
          label={t('fx_confirm_personal_address_option_2')}
          isChecked={isManual}
          onClick={() => (!isDisabled ? handleOnChange(true) : {})}
          styles={{ marginRight: '0px' }}
        />
      </>
    );
  };

  return (
    <FormGroupStyled>
      {renderFormCheckRadio1()}
      {renderFormCheckRadio2()}
    </FormGroupStyled>
  );
};

const FormGroupStyled = styled(Form.Group)`
  margin-bottom: 12px;
  position: relative;
  display: flex;
  justify-content: start;
  width: 100%;
  gap: 16px;
  ${Fade};

  @media screen and (min-width: ${DESKTOP_MIN_WIDTH}px) {
    display: table;
    margin-bottom: 12px;
    justify-content: space-between;
    clear: both;
  }
`;

export default FormInputAddressSwitch;
